import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestEffects } from './data-access/store/effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { getSavingsAccountParamsReducer, getUnitTrustAccountStatementReducer, OPEN_UNIT_TRUST_ACCOUNT_FEATURE_KEY, openUnitTrustAccountReducer, SAVINGS_ACCOUNT_PARAMS_FEATURE_KEY, UNIT_TRUST_ACCOUNT_ACCOUNT_TRANSACTIONS_KEY, UNIT_TRUST_ACCOUNT_ACCOUNTS_KEY, UNIT_TRUST_ACCOUNT_STATEMENT_FEATURE_KEY, UNIT_TRUST_FACT_SHEETS_KEY, unitTrustAccountsReducer, unitTrustAccountTransactionsReducer, unitTrustFactSheetsReducer } from './data-access/store/reducers';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(UNIT_TRUST_ACCOUNT_STATEMENT_FEATURE_KEY, getUnitTrustAccountStatementReducer),
    StoreModule.forFeature(UNIT_TRUST_ACCOUNT_ACCOUNTS_KEY, unitTrustAccountsReducer),
    StoreModule.forFeature(UNIT_TRUST_ACCOUNT_ACCOUNT_TRANSACTIONS_KEY, unitTrustAccountTransactionsReducer),
    StoreModule.forFeature(SAVINGS_ACCOUNT_PARAMS_FEATURE_KEY, getSavingsAccountParamsReducer),
    StoreModule.forFeature(UNIT_TRUST_FACT_SHEETS_KEY, unitTrustFactSheetsReducer),
    StoreModule.forFeature(OPEN_UNIT_TRUST_ACCOUNT_FEATURE_KEY, openUnitTrustAccountReducer),
    EffectsModule.forFeature([InvestEffects,]),
  ],
})
export class SbkFeatureInvestModule { }
